import { c as _c } from "react/compiler-runtime";
import { Box, HStack, Text } from '@chakra-ui/react';
import { Switch } from '@src/components/chakra-ui/switch';
import React, { useEffect, useState } from 'react';
type ToggleInputProps = {
  defaultValue?: boolean;
  uncheckedValue?: string;
  icon?: any;
  onChange: (value) => any;
  placeholder?: string;
  label?: string;
};
export const ToggleInput = props => {
  const $ = _c(15);
  const [value, setValue] = useState(props.defaultValue);
  let t0;
  if ($[0] !== props) {
    t0 = e => {
      setValue(e.target.checked);
      props.onChange(e.target.checked);
    };
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleChange = t0;
  let t1;
  if ($[2] !== props || $[3] !== value) {
    t1 = () => {
      props.onChange(value);
    };
    $[2] = props;
    $[3] = value;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== value) {
    t2 = [value];
    $[5] = value;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  useEffect(t1, t2);
  let t3;
  if ($[7] !== props.label) {
    t3 = props.label && <Text flexGrow={1} marginBottom="0.5em" opacity={0.5} textStyle="label2xs">{props.label}</Text>;
    $[7] = props.label;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== handleChange || $[10] !== value) {
    t4 = <Switch checked={value} colorPalette="teal" onChange={handleChange} />;
    $[9] = handleChange;
    $[10] = value;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t3 || $[13] !== t4) {
    t5 = <Box width="full"><HStack align="center">{t3}{t4}</HStack></Box>;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
};